import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { NewsComponent } from './news/news.component';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CkEditorComponent } from "../ck-editor/ck-editor.component";



@NgModule({
    declarations: [NewsComponent],
    imports: [
        CommonModule,
        SimplebarAngularModule,
        MatDividerModule,
        MatButtonModule,
        MatDialogModule,
        AppButtonModule,
        FontAwesomeModule,
        // CKEditorModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTooltipModule,
        CkEditorComponent,
    ],
})
export class DaveNewsModule {}
